import {
  createComponent,
  type ElementWithProps
} from '@carvana/merch-components';
import cx from 'classnames';
import { modalZIndex } from '~/constants/vdp/zIndex';

export const BackgroundWrapper = createComponent<
  ElementWithProps<{ fixed: boolean }>
>('div', props => ({
  className: cx(
    'left-0 top-0 flex h-full w-full bg-grey-3 bg-opacity-60',
    props.fixed ? 'fixed m:pr-[var(--scrollbar-width)]' : 'absolute'
  ),
  style: { zIndex: props.fixed ? modalZIndex : 101 }
}));

export const Wrapper = createComponent<ElementWithProps<{ maxWidth: string }>>(
  'div',
  props => ({
    className: `
      relative
      m-auto
      grid
      w-full
      max-w-[90%]
      gap-20
      bg-blue-6/95
      p-20
      text-blue-1
      shadow-sm
      m:max-h-[95vh]
      m:max-w-[var(--max-width)]
      m:rounded
      m:p-40
    `,
    style: { '--max-width': props.maxWidth }
  })
);

export const TitleWrap = createComponent('header', {
  className: 'flex items-center justify-center'
});

export const Title = createComponent('h2', {
  className:
    'inline-block text-left font-bold uppercase text-white tl-header-s m:text-center m:tl-header-xl'
});

export const Text = createComponent('p', {
  className: 'tl-body-s m:tl-body-m'
});

export const ButtonWrapper = createComponent('div', {
  className: 'grid grid-flow-col grid-cols-2 items-center justify-center gap-12'
});
